"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networks = void 0;
exports.networks = {
    "1": {
        order: 1,
        chainName: "Ethereum Mainnet",
        chainId: 1,
        rpcUrls: [
            "https://main-rpc.linkpool.io",
            "https://eth-mainnet.public.blastapi.io",
            "https://eth-rpc.gateway.pokt.network",
        ],
        blockExplorerUrls: ["https://etherscan.io"],
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18,
        },
    },
    "11155111": {
        order: 9,
        chainName: "Ethereum Sepolia",
        chainId: 11155111,
        rpcUrls: ["https://rpc.sepolia.org"],
        blockExplorerUrls: ["https://sepolia.etherscan.io/"],
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18,
        },
    },
    "56": {
        order: 3,
        chainName: "BNB Chain Mainnet",
        chainId: 56,
        rpcUrls: [
            "https://bsc-dataseed.binance.org",
            "https://bsc-dataseed1.defibit.io",
            "https://bsc-dataseed1.ninicoin.io",
        ],
        blockExplorerUrls: ["https://bscscan.com"],
        nativeCurrency: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18,
        },
    },
    "97": {
        order: 4,
        chainName: "BNB Chain Testnet",
        chainId: 97,
        rpcUrls: [
            "https://data-seed-prebsc-1-s1.binance.org:8545",
            "https://data-seed-prebsc-2-s1.binance.org:8545",
            "http://data-seed-prebsc-1-s2.binance.org:8545",
            "http://data-seed-prebsc-2-s2.binance.org:8545",
            "https://data-seed-prebsc-1-s3.binance.org:8545",
            "https://data-seed-prebsc-2-s3.binance.org:8545",
        ],
        blockExplorerUrls: ["https://testnet.bscscan.com"],
        nativeCurrency: {
            name: "tBNB",
            symbol: "tBNB",
            decimals: 18,
        },
    },
    "137": {
        order: 5,
        chainName: "Polygon Mainnet",
        chainId: 137,
        rpcUrls: [
            "https://polygon-mainnet.public.blastapi.io",
            "https://matic-mainnet-archive-rpc.bwarelabs.com",
            "https://rpc-mainnet.matic.quiknode.pro",
            "https://polygon-rpc.com",
        ],
        blockExplorerUrls: ["https://polygonscan.com"],
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
        },
    },
    "80002": {
        order: 6,
        chainName: "Polygon Amoy",
        chainId: 80002,
        rpcUrls: [
            "https://rpc-amoy.polygon.technology",
            "https://rpc.ankr.com/polygon_amoy",
            "https://polygon-bor-amoy-rpc.publicnode.com",
        ],
        blockExplorerUrls: ["https://amoy.polygonscan.com"],
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
        },
    },
    "10000": {
        order: 7,
        chainName: "Gemunion Mainnet",
        chainId: 10000,
        rpcUrls: ["https://besu.gemunion.io"],
        blockExplorerUrls: ["https://besu-explorer.gemunion.io"],
        nativeCurrency: {
            name: "GEM",
            symbol: "GEM",
            decimals: 18,
        },
    },
    "10001": {
        order: 8,
        chainName: "Gemunion Testnet",
        chainId: 10001,
        rpcUrls: ["http://127.0.0.1:8545"],
        blockExplorerUrls: ["http://localhost:8080"],
        nativeCurrency: {
            name: "GEM",
            symbol: "GEM",
            decimals: 18,
        },
    },
    "1501869": {
        order: 9,
        chainName: "Waterfall Testnet9",
        chainId: 1501869,
        rpcUrls: ["https://rpc.testnet9.waterfall.network"],
        blockExplorerUrls: ["https://explorer.testnet9.waterfall.network/"],
        nativeCurrency: {
            name: "WATER",
            symbol: "WATER",
            decimals: 18,
        },
    },
};
//# sourceMappingURL=networks.js.map